import { ROUTES } from '@constants/routes';
import {
  AssessmentOutlined,
  DashboardOutlined,
  PaymentsOutlined,
  PeopleOutlined,
  SchoolOutlined,
  SettingsOutlined,
} from '@mui/icons-material';

/** Top navigation entries, shared by the desktop TopbarNav and the mobile drawer. */
export const NAV_ITEMS = [
  { label: 'Dashboard',    Icon: DashboardOutlined,  route: ROUTES.DASHBOARD,    adminOnly: false },
  { label: 'Users',        Icon: PeopleOutlined,     route: ROUTES.USERS,        adminOnly: true  },
  { label: 'Admission',    Icon: SchoolOutlined,     route: ROUTES.ADMISSIONS,   adminOnly: false },
  { label: 'Installments', Icon: PaymentsOutlined,   route: ROUTES.INSTALLMENTS, adminOnly: false },
  { label: 'Reports',      Icon: AssessmentOutlined, route: ROUTES.REPORTS,      adminOnly: true  },
  { label: 'Settings',     Icon: SettingsOutlined,   route: ROUTES.SETTINGS,     adminOnly: false },
] as const;
